<template>
  <div v-if="props.roomCapacity">
    <InputBlock
      v-for="(_, index) in (props.roomCapacity - 1)"
      :key="index"
      :prop="`extras.roommates.${index}`"
      :label="index === 0 ? props.section.$t('poly.formBasic.roommates') : ''"
    >
      <Select
        :model-value="form.extras?.roommates?.[index]"
        :options="roommateOptions"
        :placeholder="props.section.$t('poly.formBasic.selectRoommate')"
        filterable
        clearable
        :disabled="props.disabled"
        :remote-method="searchRoommates"
        remote-show-suffix
        @update:model-value="(value) => {
          _set(form, `extras.roommates.${index}`, value);
          form.extras.roommates = (form.extras.roommates || []).filter(Boolean);
        }"
      />
    </InputBlock>

    <div
      v-if="props.disabled"
      class="text-sm text-gray-500 mb-4 -mt-2"
      v-html="useT('poly.formBasic.roommatesDisabled.hint')"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  section: {
    type: Object,
    required: true,
  },
  form: {
    type: Object,
    required: true,
  },
  guest: {
    type: Object,
    default: null,
  },
  event: {
    type: Object,
    required: true,
  },
  roomCapacity: {
    type: Number,
    required: true,
  },
  roommatePropertiesIds: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

// Refs
const availableRoommates = ref([]);

// Computed
const roommateOptions = computed(() => useGuestStore().getRoommateOptions({
  availableRoommates: availableRoommates.value,
  form: props.form,
  roommatePropertiesIds: props.roommatePropertiesIds,
}));

// Methods
const searchRoommates = async(query = '') => {
  const response = await useApi.get('/public/guests/available-roommates', {
    params: {
      event: props.event?._id,
      allowedGuests: props.section.data?.value?.roommatesAllowedGuests,
      search: query,
    },
  }).catch(() => {
    useToast.error(props.section.$t('poly.errorLoadingDataRefresh'));
  });

  availableRoommates.value = response || [];
};

onMounted(() => {
  searchRoommates();
});
</script>
